import React from "react";
import { HeartIcon } from "lucide-react";
import { OfferLink } from "./OfferLink";
import { PageFan } from "./PageFan";
import { Daisy } from "./decor/Daisy";
import { LeafSprig } from "./decor/LeafSprig";
import { productVisuals } from "../data/offer";
export function Hero() {
  return <section id="top" className="relative overflow-hidden bg-ivory" data-id="element-119" data-mp="4m8msdv40tlg">
      <LeafSprig className="pointer-events-none absolute -left-3 top-24 hidden w-20 -rotate-12 lg:block" data-id="element-120" data-mp="4jvup7vn12uo" />
      <Daisy className="pointer-events-none absolute right-[46%] top-10 hidden w-8 lg:block" data-id="element-121" data-mp="xae9h65q4snx" />

      <div className="mx-auto grid max-w-6xl items-center gap-x-14 gap-y-8 px-5 pb-20 pt-8 md:pt-14 lg:grid-cols-2 lg:pb-24" data-id="element-122" data-mp="x8jjhdfliacz">
        <div className="text-center lg:self-end lg:text-left" data-id="element-123" data-mp="ncq1vfn0rqoc">
          <p className="inline-flex items-center gap-2 rounded-full bg-royal-light px-4 pb-1 pt-1.5 font-display text-xs font-bold tracking-[0.12em] text-royal md:text-sm" data-id="element-124" data-mp="nekn6v27dksy">
            <HeartIcon className="h-3.5 w-3.5 fill-rosy text-rosy" aria-hidden="true" data-id="element-125" data-mp="380w020y5mzeq" />
            PETITES HISTOIRES, GRANDE FOI
          </p>
          <p className="mt-4 font-display text-[1.6rem] font-extrabold uppercase leading-[1.05] text-royal md:text-[2rem]" data-id="element-126" data-mp="3o7c0y05rgtho">
            Le Méga Pack
            <span className="block text-tangerine" data-id="element-127" data-mp="399tex5kgwudx">de Paraboles Chrétiennes</span>
          </p>
        </div>

        <div className="lg:col-start-2 lg:row-span-2 lg:row-start-1" data-id="element-128" data-mp="3e7l5nw9dmagj">
          {productVisuals.heroMockup ? <img src={productVisuals.heroMockup} alt="Le Méga Pack de Paraboles Chrétiennes" className="mx-auto w-full max-w-[540px]" data-id="element-129" data-mp="30fy8zvbiuzx8" /> : <PageFan data-id="element-130" data-mp="2qi0jz5lu8z3k" />}
        </div>

        <div className="text-center lg:self-start lg:text-left" data-id="element-131" data-mp="2vjzqupgsee59">
          <div className="inline-flex items-center gap-4 rounded-[1.5rem] border-[3px] border-tangerine bg-sun-light px-5 py-3 text-left" data-id="element-132" data-mp="2hj5ig6tqod6l">
            <div className="flex flex-col items-center leading-none" data-id="element-133" data-mp="2ljgxn43c1lao">
              <span className="font-display text-xs font-extrabold tracking-widest text-tangerine-dark" data-id="element-134" data-mp="s2jnhxye22k1">
                PLUS DE
              </span>
              <span className="font-display text-5xl font-extrabold text-tangerine" data-id="element-135" data-mp="na08cwk1yzd4">50</span>
            </div>
            <p className="font-display text-sm font-bold leading-tight text-royal md:text-base" data-id="element-136" data-mp="ia5k70rnwnvr">
              PARABOLES ILLUSTRÉES
              <br data-id="element-137" data-mp="1b0nmhzkkal84" />+ ACTIVITÉS BIBLIQUES
            </p>
          </div>

          <h1 className="mt-6 font-display text-[1.9rem] font-bold leading-[1.15] text-royal-deep md:text-[2.6rem] md:leading-[1.1]" data-id="element-138" data-mp="1ayji7gir3k7b">
            Transmettez votre foi à vos enfants et créez de{" "}
            <span className="text-tangerine" data-id="element-139" data-mp="114ki0n28mai0">précieux moments en famille</span> autour de la
            Parole de Dieu.
          </h1>
          <p className="mx-auto mt-4 max-w-xl text-base leading-relaxed text-cocoa-soft md:text-lg lg:mx-0" data-id="element-140" data-mp="3ltgnrsgieupe">
            Des histoires touchantes, des versets bibliques et des activités à imprimer pour
            apprendre, échanger et grandir ensemble dans la foi.
          </p>

          <div className="mt-8 flex flex-col items-center gap-3 lg:items-start" data-id="element-141" data-mp="21amwtbz2vwne">
            <OfferLink className="w-full sm:w-auto" data-id="element-142" data-mp="218jw9y0aul4f">DÉCOUVRIR LE MÉGA PACK</OfferLink>
            <p className="text-xs font-bold text-cocoa-soft md:text-sm" data-id="element-143" data-mp="267wicgjcjo5y">
              Format numérique à imprimer • Paiement unique • Garantie 7 jours
            </p>
          </div>
        </div>
      </div>
    </section>;
}